import { S200UKI_CONNECTOR_BASE_URL } from 'constants/Environment';

import { connectorClient } from './connectorClient';

const SAGE_ID_VENDOR_ID = 44;

const normalizeBaseUrl = (url) => url.replace(/\/$/, '');

export const fetchSession = (sessionId) =>
    connectorClient.get('/api/v1/implementation/session', {
        params: { sessionId },
    });

export const createImplementation = (body) => connectorClient.post('/implementations', body);

export const fetchImplementationStatus = (tag) =>
    connectorClient.get('/implementations/status', {
        params: { tag },
    });

export const buildSageIdLoginUrl = () =>
    `${normalizeBaseUrl(S200UKI_CONNECTOR_BASE_URL)}/api/v1/implementation/sageId?vendorId=${SAGE_ID_VENDOR_ID}`;
